import { formatCurrency } from './currency_utils'

// One value formatter for every summary table: purse through the league's
// currency, points as an integer when whole (2 decimals otherwise), missing
// values as a dash.
export const formatSummaryValue = (metric, value, currencySymbol, purseDecimalPlaces) => {
  if (value === undefined || value === null) { return '-' }
  if (metric === 'purse') { return formatCurrency(value, currencySymbol, purseDecimalPlaces) }
  const n = Number(value)
  return n % 1 === 0 ? String(Math.round(n)) : n.toFixed(2)
}
